import { tw } from "@careinfo/tailwind";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/Endpoint";
import usePostHook from "../../customHooks/usePostHook";
import { createAccount } from "../../validation/AccountInfo";
import Button from "../Reusable/Button";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextField";

const CreateItems = ({ setIsOpenItemsPopup }) => {
  const {
    control,
    setValue,
    handleSubmit,
    setError,
    formState: { errors },
    getValues,
    register,
    clearErrors,
  } = useForm({
    resolver: yupResolver(createAccount),
  });

  const { mutateAsync, isPostLoading } = usePostHook({
    queryKey: ["items"],
  });

  const handleCreate = async (values: any, setError: any) => {
    const url = APIS.COA;
    const formData = {
      ...values,
      root_account: "f8e9d0a1-2b3c-4d5e-6f7a-8b9c0d1e2f3a",
      is_group: false,
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
      if (res?.status === 201) {
        setIsOpenItemsPopup(false);
      }
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <form
      className={tw`w-full min-w-[400px]`}
      onSubmit={handleSubmit((data) => handleCreate(data, setError))}
    >
      <div className={tw``}>
        <TextField
          control={control}
          name={"name"}
          label={"Name"}
          placeholder="Enter Items Name..."
        />
        <ComboboxInput
          url={APIS.COA}
          queryKey="account"
          label={"Account"}
          props={{
            parent: "f8e9d0a1-2b3c-4d5e-6f7a-8b9c0d1e2f3a",
          }}
          register={register("parent")}
          errors={errors?.parent}
          setValue={setValue}
          name={"parent"}
          getValues={getValues}
          clearErrors={clearErrors}
        />
      </div>
      <div className={tw`flex justify-end w-full`}>
        <div className={tw`w-24`}>
          <Button label="Save" isLoading={isPostLoading} />
        </div>
      </div>
    </form>
  );
};

export default CreateItems;
